import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BiRupee } from "react-icons/bi";
import { HiBadgeCheck } from "react-icons/hi";
import { BsBookmarkStarFill, BsStarFill } from "react-icons/bs";
import Rating from "../Rating";
import { ToastContainer } from "react-toastify";
import { SERVER_PATH } from "../../config/env";
import { userInfo } from "../../utils/appInfo";
import { successToaster } from "../../utils/index";
import { getLocalStorage } from "./../../utils/helper";
import apiClient from "../../utils/api";
import "./styles.css";

export default function Product(props) {
  const isLogin = getLocalStorage("uid") ? true : false;
  let nav = useNavigate();
  const [count, setCount] = useState(1);
  const [ratings, setRatings] = useState(0);
  const [allRating, setAllRating] = useState();
  const [data, setData] = useState([]);
  const param = useParams();
const [userData, setUserData] = useState(null);
  const [showNumber, setShowNumber] = useState(false);
 const [alreadyInCart, setAlreadyInCart] = useState(false);



  // const [userRating, setUserRating] = useState([]);

  const handleIncrement = () => {
    setCount((prevCount) => prevCount + 1);
  };

  const handleDecrement = () => {
    if (count != 1) setCount((prevCount) => prevCount - 1);
  };

  const toggleState = (clickState) => {
    setRatings(clickState);
  };

  const fetchData = () => {
    apiClient
      .post(`get/product.php`, {
        product_id: param.productId,
      })
      .then((res) => {
        let info = res.data.length ? res.data[0] : {};
        setData(info);
        setCount(1);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const postData = async (e) => {
    if (isLogin === false) {
      nav("/profile/:productId");
    } else {
      e.preventDefault();
      let info = {
        product_id: param.productId,
        user_id: userData.email,
        quantity: count,
      };

      apiClient
        .post(`post/cart.php`, { ...info })
        .then(() => {
          successToaster({ msg: "Added to cart" });
          setCount(1);
        })
        .then(() => {})
        .catch((err) => {
          console.log(err);
        });
    }
  };

  useEffect(() => {
    if (!userData) return;
    apiClient.post("get/cart.php", { user_id: userData.email }).then((res) => {
      const exists = res.data.some(
        (item) => item.product_id == param.productId
      );
      setAlreadyInCart(exists);
    });
  }, [userData, param.productId]);


//   const buyPostData = async (e) => {
//   if (!isLogin) {
//     nav("/profile/:productId");
//   } else {
//     e.preventDefault();
//     let info = {
//       product_id: param.productId,
//       user_id: userData.email,
//       quantity: count,   
//     };

//     apiClient
//       .post(`post/cart.php`, { ...info })
//       .then(() => {
//         nav("/cart/:productId");
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   }
// };

// const buyPostData = async (e) => {
//   if (!isLogin) {
//     nav("/profile/:productId");
//   } else {
//     e.preventDefault();

//     // ❗ IF count > 1 → API should NOT run
//     if (count > 1) {
//       nav("/cart/:productId"); // or return; if you want nothing to happen
//       return; // STOP here
//     }

//     // Only count === 1 allowed
//     let info = {
//       product_id: param.productId,
//       user_id: userData.email,
//       quantity: count,
//     };

//     apiClient
//       .post(`post/cart.php`, { ...info })
//       .then(() => {
//         nav("/cart/:productId");
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   }
// };

const buyPostData = async (e) => {
  if (!isLogin) {
    nav("/profile/:productId");
  } else {
    e.preventDefault();

    if (alreadyInCart) {
      nav("/cart/:productId"); // just open cart
      return;
    }

    let info = {
      product_id: param.productId,
      user_id: userData.email,
      quantity: 1,
    };

    apiClient
      .post(`post/cart.php`, info)
      .then(() => {
        setAlreadyInCart(true); // now mark as added
        nav("/cart/:productId");
      })
      .catch((err) => console.log(err));
  }
};




  const swapFocusImg = (key) => {
    let info = { ...data };
    info[key] = info.img1;
    info.img1 = data[key];
    setData(info);
  };

  const overallRating = async () => {
    await apiClient
      .post(`get/ratings.php`, {
        product_id: param.productId,
      })
      .then((res) => {
        setAllRating(res.data);
      });
  };

  // const getUserRating = async () => {
  //   await axios
  //     .post(`${SERVER_PATH}get/ratings.php`, {
  //       user_id: userData.email,
  //       product_id: param.productId,
  //     })
  //     .then((res) => {
  //       setUserRating(res.data.rating);
  //     });
  // };

  const submitRating = async (rate) => {
    apiClient
      .post(`post/ratings.php`, {
        user_id: userData.email,
        product_id: param.productId,
        rating: rate,
      })
      .then((res) => {
        successToaster({ msg: "Rating added successfully" });
        overallRating();
      });
  };

  useEffect(() => {
    setTimeout(() => {
      setUserData(userInfo());
      fetchData();
      overallRating();
      window.scrollTo(0, 0);
    }, 200);
  }, [param.productId]);

  return (
    <>
      <section className="productPage" key={data.product_id}>
        <div className="container-fluid pb-5 product">
          <div className="row">
            <div className="col-lg-5 mt-5">
              <div className="card mb-3">
                <img
                  className="card-img img-fluid productDetailImg"
                  src={data.img1}
                  alt="Janu's Food Products"
                  id="product-detail"
                />
              </div>
              <div className="row">
                <div className="col-1 align-self-center"></div>
                <div
                  id="multi-item-example"
                  className="col-10 carousel slide carousel-multi-item"
                  data-bs-ride="carousel"
                >
                  <div
                    className="carousel-inner product-links-wap"
                    role="listbox"
                  >
                    <div className="carousel-item active">
                      <div className="row">
                        <div
                          className="col-4"
                          onClick={() => {
                            swapFocusImg("img2");
                          }}
                        >
                          <img
                            className="card-img img-fluid productDetailSubImg"
                            src={data.img2}
                            alt="Janu's Food Products"
                          />
                        </div>
                        <div
                          className="col-4"
                          onClick={() => {
                            swapFocusImg("img3");
                          }}
                        >
                          <img
                            className="card-img img-fluid productDetailSubImg"
                            src={data.img3}
                            alt="Janu's Food Products"
                          />
                        </div>
                        <div
                          className="col-4"
                          onClick={() => {
                            swapFocusImg("img4");
                          }}
                        >
                          <img
                            className="card-img img-fluid productDetailSubImg"
                            src={data.img4}
                            alt="Janu's Food Products"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-1 align-self-center"></div>
              </div>
            </div>
            <div className="col-lg-7 mt-5">
              <div className="card">
                <div className="cards-body-new m-3">
                  <div className="d-flex justify-content-between align-items-start ">
                    <h1 className="h5 text-uppercase productDetailTitle">
                      {data.product_name}{" "}
                      <small
                        style={{ fontSize: "15px" }}
                        className="products-gms"
                      >
                        ({data.weight} Gms.)
                      </small>
                    </h1>
                    {/* <button
                      type="button"
                      className="btn btn-outline-secondary btn-sm"
                      data-bs-toggle="modal"
                      data-bs-target="#infoModal"
                      style={{
                        borderRadius: "50%",
                        width: "30px",
                        height: "30px",
                        padding: "0",
                      }}
                      title="More Info"
                    >
                      i
                    </button> */}
                  </div>
                  <div
                    className="modal fade"
                    id="infoModal"
                    tabIndex="-1"
                    aria-labelledby="infoModalLabel"
                    aria-hidden="true"
                  >
                    <div className="modal-dialog modal-dialog-centered">
                      <div
                        className="modal-content border-0 text-center p-4"
                        style={{ borderRadius: "20px" }}
                      >
                        <button
                          type="button"
                          className="btn-close position-absolute end-0 m-3"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>

                        <img
                          src="https://cdn-icons-png.flaticon.com/512/564/564619.png"
                          alt="Alert"
                          width="60"
                          className="mx-auto mb-3"
                        />

                        <h5 className="mb-3">
                          If you'd like to return the product, please contact
                          this number immediately.
                        </h5>
                        <div
                          className="cursor-pointer hover:scale-110 transition-transform"
                          onClick={() => setShowNumber(!showNumber)}
                        >
                          👋
                        </div>
                        {showNumber && (
                          <div className="mt-4 text-blue-600 font-bold">
                            1234567890
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <p>
                    <span
                      className="list-inline-item text-dark fw-700 rupees-size"
                      style={{ fontSize: "1.4em" }}
                    >
                      <BiRupee style={{ marginTop: "-3px" }} />
                      {parseInt(
                        (data.offer_price =
                          data.price - (data.price * data.offer) / 100)
                      )}
                    </span>
                    <span
                      className="list-inline-item text-secondary rupees-size-1"
                      style={{
                        fontSize: "1em",
                        textDecoration: "line-through",
                      }}
                    >
                      <BiRupee style={{ marginTop: "-3px" }} />
                      {data.price}
                    </span>
                    <span
                      className="list-inline-item rupees-size-1"
                      style={{ fontSize: "1em", color: "green" }}
                    >
                      {Number(data.offer) % 1 === 0
                        ? Math.round(data.offer)
                        : data.offer}
                      %<small style={{ fontSize: ".7em" }}>Discount</small>
                    </span>
                  </p>
                  <form>
                    <input
                      type="hidden"
                      name="product-title"
                      value="Activewear"
                    />
                    <div className="col-auto">
                      <ul className="list-inline pb-3">
                        <li className="list-inline-item text-right rupees-size">
                          Quantity
                          <input
                            type="hidden"
                            name="product-quanity"
                            id="product-quanity"
                            value="1"
                          />
                        </li>
                        <li className="list-inline-item">
                          <span
                            className="btn btn-sm btn-success rupees-size-2"
                            id="btn-minus"
                            onClick={handleDecrement}
                          >
                            -
                          </span>
                        </li>
                        <li className="list-inline-item">
                          <span
                            className="badge bg-light text-dark rupees-size-2"
                            id="var-value"
                          >
                            {count}
                          </span>
                        </li>
                        <li className="list-inline-item">
                          <span
                            className="btn btn-sm btn-success rupees-size-2"
                            id="btn-plus"
                            onClick={handleIncrement}
                          >
                            +
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div className="row pb-3">
                      <div className="col d-grid">
                        {data.status == 0 ? (
                          <button
                            disabled
                            onClick={buyPostData}
                            type="submit"
                            className="btn btn-success btn-sm py-2 text-uppercase btn-height"
                            name="submit"
                            value="buy"
                            // style={{
                            //   borderRadius: "0",
                            //   letterSpacing: ".2px",
                            //   fontWeight: "500",
                            // }}
                          >
                            Buy Now
                          </button>
                        ) : (
                          <button
                            onClick={buyPostData}
                            type="submit"
                            className="btn btn-success btn-sm py-2 text-uppercase "
                            name="submit"
                            value="buy"
                            disabled={data.status === 0}
                          >
                            Buy Now
                          </button>
                        )}
                      </div>
                      <div className="col d-grid">
                        {data.status == 0 ? (
                          <button
                            disabled
                            onClick={postData}
                            type="submit"
                            className="btn btn-warning btn-sm py-2 text-uppercase "
                            name="submit"
                            value="addtocard"
                            style={{
                              borderRadius: "0",
                              letterSpacing: ".2px",
                              fontWeight: "500",
                            }}
                          >
                            Add To Cart
                          </button>
                        ) : (
                          <button
                            onClick={postData}
                            type="submit"
                            className="btn btn-warning btn-sm py-2 text-uppercase"
                            name="submit"
                            value="addtocard"
                            style={{
                              borderRadius: "0",
                              letterSpacing: ".2px",
                              fontWeight: "500",
                            }}
                          >
                            Add To Cart 
                          </button>
                        )}
                      </div>
                    </div>
                  </form>
                  <h6
                    className="text-uppercase mt-3 rupees-size"
                    style={{ color: "#0f0c0cff" }}
                  >
                    Description:
                  </h6>
                  <p className="rupees-size-2">{data.description}</p>
                  <h6
                    className="text-uppercase mt-3 rupees-size"
                    style={{ color: "#000", fontSize: "15px" }}
                  >
                    <HiBadgeCheck
                      style={{
                        marginTop: "-4px",
                        color: "green",
                        fontSize: "20px",
                      }}
                      className="me-1 rupees-size"
                    />
                    Ingredients:
                  </h6>
                  <ul className="text-capitalize pb-2 ingrediants ">
                    <li className="rupees-size-2">{data.ingredients}</li>
                  </ul>
                  <h6
                    className="text-uppercase mt-3 rupees-size"
                    style={{ color: "#000", fontSize: "15px" }}
                  >
                    <HiBadgeCheck
                      style={{
                        marginTop: "-4px",
                        color: "green",
                        fontSize: "20px",
                      }}
                      className="me-1 rupees-size"
                    />
                    Methods of Application:
                  </h6>
                  <p
                    style={{
                      fontSize: "15px",
                      textAlign: "justify",
                      lineHeight: "1.7em",
                      fontWeight: "350",
                    }}
                    className="rupees-size-2"
                  >
                    {data.instructions}
                  </p>
                </div>
              </div>
              <div className="card mt-2">
                <div className="cards-body-new m-3">
                  <div className="d-flex align-items-center position-relative ratingDiv">
                    <h1
                      className="h5 text-capitalize rupees-size"
                      style={{ color: "#000", fontSize: "20px" }}
                    >
                      Ratings
                    </h1>
                    <button
                      className="position-absolute end-0 rupees-size"
                      onClick={(e) => {
                        toggleState(1);
                      }}
                    >
                      Rate Product
                    </button>
                  </div>
                  <h6
                    className="text-uppercase mt-3 mb-3 ratings-size"
                    style={{ color: "#000", fontSize: "15px" }}
                  >
                    <BsBookmarkStarFill className="me-1 ratings-size" />
                    Overall Ratings
                  </h6>
                  <div className="d-flex align-items-center">
                    <span style={{ fontSize: "1.5em" }} className="rupees-size">
                      {allRating}
                    </span>
                    &nbsp;
                    <BsStarFill className="rupees-size-2" />
                    &nbsp;
                  </div>
                </div>
                {ratings === 1 ? (
                  <div className="card-body">
                    <h5 className="rupees-size">Enter Your Ratings</h5>
                    <Rating
                      rating={ratings}
                      onRating={(rate) => {
                        setRatings(rate);
                      }}
                      submitRating={submitRating}
                    />
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
    </>
  );
}
